import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';

export const MapSection = () => {
  const mapUrl = process.env.REACT_APP_GOOGLE_MAPS_EMBED_URL || 
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29876.5!2d-109.9167!3d22.8905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af4b0b0b0b0b0b%3A0x0!2sCabo%20San%20Lucas!5e0!3m2!1ses!2smx!4v1234567890';

  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="flex items-center justify-center space-x-2 mb-4">
            <MapPin className="h-6 w-6 text-primary" />
            <span className="text-primary font-semibold text-sm uppercase tracking-wide">
              Nuestra Ubicación
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            Visítanos en Cabo San Lucas
          </h2>
          <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
            Calle 12 de octubre entre Ignacio Zaragoza y Melchor Ocampo, mz. 51 lt. 5, Local #4, Col. Idelfonso Green CP 23470, Cabo San Lucas, BCS
          </p>
          <p className="text-md text-gray-500 mt-2">
            <strong>Cobertura:</strong> Cabo San Lucas, San José del Cabo y La Paz, B.C.S.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="rounded-2xl overflow-hidden shadow-2xl"
        >
          <iframe
            src={mapUrl}
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen={false}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicación RentaPrint en Cabo San Lucas"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default MapSection;
